import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

class VideoModalStore extends BaseModalStore {
  @observable closeCallback = noop;
  @observable videoUrl = '';

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 设置视频链接
   * @param {string} url - 视频链接
   */
  setVideoUrl = url => {
    this.videoUrl = url;
  };

  /**
   * 打开弹窗并设置视频链接
   * @param {string} url - 视频链接
   */
  openWithVideo = url => {
    this.videoUrl = url;
    this.isOpen = true;
    this.isActive = true;
    this.setModalStyles();
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.videoUrl = '';
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    // 不调用 super.use()，避免自动激活弹窗
    // 弹窗的显示由外部手动控制 isOpen 和 isActive
  }
}

export default VideoModalStore;
